import React, { useState } from 'react';
import { Helper } from '../static/helper';
const Cta = () => {
    const [isHovered, setIsHovered] = useState(false);

    const handleMouseEnter = () => {
        setIsHovered(true);
    };

    const webSite = () => {
        window.open(Helper.urlReservation)
    }

    const handleMouseLeave = () => {
        setIsHovered(false);
    };
    return (
        <div className="w-full flex items-center justify-center text-white cta">
            <div className="mx-8 w-full h-96 text-center lg:text-left py-16 px-12 flex lg:justify-between items-center">
                <div className="w-full flex flex-col lg:flex-row lg:justify-around">
                    <div className="mb-4">
                        <p className='text-2xl md:text-4xl font-bold mb-4'>Vous avez une douleur ?</p>
                        <p className="text-lg md:text-2xl">Un renseignement ?</p>
                    </div>

                    <div className="w-full lg:w-72 pt-6 lg:mx-12">
                        <button style={{background: isHovered ? Helper.footerBackGroundColor : "transparent", borderColor: isHovered ? Helper.footerBackGroundColor : "white"}} onMouseEnter={handleMouseEnter}  onMouseLeave={handleMouseLeave} className="bg-transparent border text-white justify-center text-center rounded-lg px-10 py-3 flex items-center group" smooth onClick={webSite} >
                            Prendre rendez - vous
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Cta;